"use client";

import { Modal } from "@/components/Modal";
import { NormalText } from "@/components/text/NormalText";
import { SECONDS_MAX_EDIT_IN_PITCH_EDITOR } from "@/constants/constants";

export function InvalidLengthEditModal({
  open,
  closeModal,
}: {
  open: boolean;
  closeModal: () => void;
}) {
  return (
    <Modal
      open={open}
      closeModal={closeModal}
      title="Invalid audio length"
      widthMode="normal"
    >
      <NormalText elementType="p">
        The maximum audio file length for editing is{" "}
        {SECONDS_MAX_EDIT_IN_PITCH_EDITOR} seconds. Please select a shorter
        file.
      </NormalText>
    </Modal>
  );
}
